import { render } from "./audio.vue?vue&type=template&id=4270e74a&scoped=true"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"

import "./audio.vue?vue&type=style&index=0&id=4270e74a&lang=less&scoped=true"

import exportComponent from "D:\\huiwu\\wgt_user_web_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4270e74a"]])

export default __exports__